export const MENSAGEM_CONFIRMACAO_GERAR_ARQUIVO_IMPORTACAO_DIMOB = "O Imob86 não se responsabiliza por qualquer erro de informação ou omissão, visto que,"
+ " a geração e emissão do relatório e arquivo de importação, bem como a entrada e manutenção destes"
+ " dados no programa Dimob, é responsabilidade única e exclusiva dos usuários dos sistemas.";

export const TITULO_CONFIRMACAO_GERAR_ARQUIVO_IMPORTACAO_DIMOB = "Sobre a geração do arquivo de importação";